<template>
  <div class="card">
    <div class="card-header">
      <h3>Top-up History</h3>
      <small class="form-text text-muted">Most recent 20 attempts, newest first.</small>
    </div>
    <div class="card-body">
      <div v-if="isLoading" class="text-center py-3">
        <span class="spinner-border spinner-border-sm me-2"></span> Loading...
      </div>
      <div v-else-if="topUps.length === 0" class="text-muted">No top-up attempts yet.</div>
      <div v-else class="table-responsive">
        <table class="table table-borderless">
          <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Refund</th>
            <th>Refundable Remainder</th>
            <th>Failure</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="topUp in topUps" :key="topUp.id">
            <td>{{ formatDate(topUp.createdOn) }}</td>
            <td v-html="minorCurrency(topUp.amountMinor)"></td>
            <td>{{ topUp.status }}</td>
            <td v-html="walletTopUpRefundState(topUp.refundState)"></td>
            <td v-html="minorCurrency(topUp.refundableRemainderMinor)"></td>
            <td class="text-muted">{{ topUp.failureMessage || topUp.refundFailureMessage || '' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { minorCurrency, walletTopUpRefundState } from '../utility/DatatableRenderer';

const props = defineProps({
  walletId: { type: String, required: true }
});

const topUps = ref([]);
const isLoading = ref(false);

const formatDate = (value) => value ? new Date(value).toLocaleString() : '';

const loadTopUps = async () => {
  isLoading.value = true;
  try {
    const response = await fetch(`/api/admin/wallets/${props.walletId}/top-ups`);
    if (response.ok) {
      topUps.value = await response.json();
    }
  } catch (error) {
    console.error('Error loading wallet top-ups:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(loadTopUps);

defineExpose({ loadTopUps });
</script>
